import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-container non-scrollable" }
const _hoisted_2 = { class: "d-flex orders-grid scrollable" }
const _hoisted_3 = { class: "paginator" }

import { useStaffStore } from '@/store/StaffStore';
import StaffOrderItem from '@/components/StaffOrderItem.vue'; 
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FinishedOrders',
  setup(__props) {

const staffStore = useStaffStore();
staffStore.loadFinishedOrders(1);

// function changePageClick(pg: number){
//     staffStore.loadFinishedOrders(pg);
//     console.log("chanign page to "+pg);
// }

const page = computed({
            get: () => staffStore.finishedOrdersPage,
            set: val => {
                staffStore.loadFinishedOrders(val);
            }
        })


return (_ctx: any,_cache: any) => {
  const _component_vue_awesome_paginate = _resolveComponent("vue-awesome-paginate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(staffStore).finishedOrders, (order) => {
        return (_openBlock(), _createBlock(StaffOrderItem, {
          class: "order-block",
          key: order.id,
          order: order,
          "show-percentage": false,
          percentage: 0
        }, null, 8, ["order"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_vue_awesome_paginate, {
        "total-items": _unref(staffStore).finishedOrdersTotalCount,
        "items-per-page": _unref(staffStore).finishedOrdersPageSize,
        modelValue: _unref(page),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null))
      }, null, 8, ["total-items", "items-per-page", "modelValue"])
    ])
  ]))
}
}

})